<template>
	<div>
		<wc-header headerTitle="设备信息" :BackisShow=BackisShow></wc-header>
		<wc-device></wc-device>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				BackisShow:true
			}
		}
	}
</script>
<style>
	body{
		background: #F3F3F3;
	}
</style>


// WEBPACK FOOTER //
// src/views/device/Device.vue